module.exports = __webpack_public_path__ + "img/Ahmed-Zulfiqar.5e1cc673.jpg";